// Country flag using self-hosted SVGs from /flags/
// Falls back to emoji text if the image fails to load

// Maps FIFA/team codes to ISO 3166-1 alpha-2 (or region) codes used by flag SVGs
const CODE_MAP: Record<string, string> = {
  ALG: "dz",
  ARG: "ar",
  AUS: "au",
  AUT: "at",
  BEL: "be",
  BIH: "ba",
  BRA: "br",
  CAN: "ca",
  CIV: "ci",
  COD: "cd",
  COL: "co",
  CPV: "cv",
  CRO: "hr",
  CUW: "cw",
  CZE: "cz",
  ECU: "ec",
  EGY: "eg",
  ENG: "gb-eng",
  ESP: "es",
  FRA: "fr",
  GER: "de",
  GHA: "gh",
  HAI: "ht",
  IRN: "ir",
  IRQ: "iq",
  JOR: "jo",
  JPN: "jp",
  KOR: "kr",
  KSA: "sa",
  MAR: "ma",
  MEX: "mx",
  NED: "nl",
  NOR: "no",
  NZL: "nz",
  PAN: "pa",
  PAR: "py",
  POR: "pt",
  QAT: "qa",
  RSA: "za",
  SCO: "gb-sct",
  SEN: "sn",
  SUI: "ch",
  SWE: "se",
  TUN: "tn",
  TUR: "tr",
  URU: "uy",
  USA: "us",
  UZB: "uz",
};

export default function CountryFlag({ code, emoji, size = 20 }: { code: string; emoji: string; size?: number }) {
  const isoCode = CODE_MAP[code] ?? code.toLowerCase();
  
  const h = Math.round(size * 0.7);

  return (
    <img
      src={`/flags/${isoCode}.png`}
      alt={emoji}
      width={size}
      height={h}
      className="inline-block shrink-0 rounded-[2px]"
      style={{ width: size, height: h, objectFit: 'cover', objectPosition: 'center' }}
      loading="lazy"
      onError={(e) => {
        const span = document.createElement('span');
        span.textContent = emoji;
        span.style.fontSize = `${size}px`;
        span.style.lineHeight = '1';
        (e.target as HTMLElement).replaceWith(span);
      }}
    />
  );
}
